import {createSlice} from "@reduxjs/toolkit";

export const initialState = {
    skills: [],
    interests: [],
    osa_offices: [
        {key: "rm", value: "Roma"},
        {key: "ml", value: "Milano"},
        {key: "Torino", value: "Torino"},
        {key: "Vicenza", value: "Vicenza"},
        {key: "Bologna", value: "Bologna"},
        {key: "Ancona", value: "Ancona"},
        {key: "Firenze", value: "Firenze"},
        {key: "Napoli", value: "Napoli"},
        {key: "Bari", value: "Bari"},
        {key: "Catania", value: "Catania"},
        {key: "Cagliari", value: "Cagliari"},
    ]
}


const slice = createSlice({
    name: "staticData",
    initialState,
    reducers: {
        downloadStaticData: (state) => {

        },
        setStaticDataSkills: (state, {payload}) => {
            state.skills = payload;
        },
        setStaticDataInterests: (state, {payload}) => {
            state.interests = payload;
        }
    }
});

const {actions, reducer} = slice;
export const {
    downloadStaticData, setStaticDataInterests, setStaticDataSkills
} = actions;
export default reducer;
